import { useMemo } from 'react';
import { P2GDate, P2GText } from '@parcel2go/core-ui';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { IsSmartSendByType, ToItemSource, ToItemSources } from '../../../lib/helpers/SmartSendSummaryGenerator';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';

interface props {
  item?: SmartSendItemApiModel;
}

const ImportedDate: React.FC<props> = (props) => {
  const itemSource = useMemo(
    () => (IsSmartSendByType(props?.item?.Type) ? ToItemSources(props.item) : ToItemSource(props.item)),
    [props.item]
  );
  return (
    <P2GText variant="body2" display="flex" gap={1} alignItems="center">
      <ECommerceLogo
        title={itemSource}
        style={{ height: '30px' }}
        integration={props.item.MarketplaceOrderLines[0]?.Source?.Id}
      />
      <P2GDate date={props.item.MarketplaceTransactionDate || props.item.Created} variant="body2" />
    </P2GText>
  );
};

export default ImportedDate;
